/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as FeedbackRouteImport } from './routes/feedback'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LaunchRouteImport } from './routes/launch'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as StripeRouteImport } from './routes/stripe'
import { Route as TemplatesRouteImport } from './routes/templates'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as TemplateTemplatePublicIdRouteImport } from './routes/template.$templatePublicId'
import { Route as TemplateNewRouteImport } from './routes/template/new'
import { Route as VisitsIndexRouteImport } from './routes/visits/index'
import { Route as VisitsVisitPublicIdRouteImport } from './routes/visits/$visitPublicId'
import { Route as AdminUsersIndexRouteImport } from './routes/admin.users.index'
import { Route as AdminUsersPublicIdRouteImport } from './routes/admin.users.$publicId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedbackRoute = FeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LaunchRoute = LaunchRouteImport.update({
  id: '/launch',
  path: '/launch',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const StripeRoute = StripeRouteImport.update({
  id: '/stripe',
  path: '/stripe',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesRoute = TemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRoute,
} as any)
const TemplateTemplatePublicIdRoute =
  TemplateTemplatePublicIdRouteImport.update({
    id: '/template/$templatePublicId',
    path: '/template/$templatePublicId',
    getParentRoute: () => rootRouteImport,
  } as any)
const TemplateNewRoute = TemplateNewRouteImport.update({
  id: '/template/new',
  path: '/template/new',
  getParentRoute: () => rootRouteImport,
} as any)
const VisitsIndexRoute = VisitsIndexRouteImport.update({
  id: '/visits/',
  path: '/visits/',
  getParentRoute: () => rootRouteImport,
} as any)
const VisitsVisitPublicIdRoute = VisitsVisitPublicIdRouteImport.update({
  id: '/visits/$visitPublicId',
  path: '/visits/$visitPublicId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersPublicIdRoute = AdminUsersPublicIdRouteImport.update({
  id: '/users/$publicId',
  path: '/users/$publicId',
  getParentRoute: () => AdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/analytics': typeof AnalyticsRoute
  '/feedback': typeof FeedbackRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/launch': typeof LaunchRoute
  '/settings': typeof SettingsRoute
  '/sign-up': typeof SignUpRoute
  '/stripe': typeof StripeRoute
  '/templates': typeof TemplatesRoute
  '/admin/audit': typeof AdminAuditRoute
  '/template/$templatePublicId': typeof TemplateTemplatePublicIdRoute
  '/template/new': typeof TemplateNewRoute
  '/visits/$visitPublicId': typeof VisitsVisitPublicIdRoute
  '/admin/': typeof AdminIndexRoute
  '/visits/': typeof VisitsIndexRoute
  '/admin/users/$publicId': typeof AdminUsersPublicIdRoute
  '/admin/users/': typeof AdminUsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/feedback': typeof FeedbackRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/launch': typeof LaunchRoute
  '/settings': typeof SettingsRoute
  '/sign-up': typeof SignUpRoute
  '/stripe': typeof StripeRoute
  '/templates': typeof TemplatesRoute
  '/admin/audit': typeof AdminAuditRoute
  '/template/$templatePublicId': typeof TemplateTemplatePublicIdRoute
  '/template/new': typeof TemplateNewRoute
  '/visits/$visitPublicId': typeof VisitsVisitPublicIdRoute
  '/admin': typeof AdminIndexRoute
  '/visits': typeof VisitsIndexRoute
  '/admin/users/$publicId': typeof AdminUsersPublicIdRoute
  '/admin/users': typeof AdminUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/analytics': typeof AnalyticsRoute
  '/feedback': typeof FeedbackRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/launch': typeof LaunchRoute
  '/settings': typeof SettingsRoute
  '/sign-up': typeof SignUpRoute
  '/stripe': typeof StripeRoute
  '/templates': typeof TemplatesRoute
  '/admin/audit': typeof AdminAuditRoute
  '/template/$templatePublicId': typeof TemplateTemplatePublicIdRoute
  '/template/new': typeof TemplateNewRoute
  '/visits/$visitPublicId': typeof VisitsVisitPublicIdRoute
  '/admin/': typeof AdminIndexRoute
  '/visits/': typeof VisitsIndexRoute
  '/admin/users/$publicId': typeof AdminUsersPublicIdRoute
  '/admin/users/': typeof AdminUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/analytics'
    | '/feedback'
    | '/forgot-password'
    | '/launch'
    | '/settings'
    | '/sign-up'
    | '/stripe'
    | '/templates'
    | '/admin/audit'
    | '/template/$templatePublicId'
    | '/template/new'
    | '/visits/$visitPublicId'
    | '/admin/'
    | '/visits/'
    | '/admin/users/$publicId'
    | '/admin/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/analytics'
    | '/feedback'
    | '/forgot-password'
    | '/launch'
    | '/settings'
    | '/sign-up'
    | '/stripe'
    | '/templates'
    | '/admin/audit'
    | '/template/$templatePublicId'
    | '/template/new'
    | '/visits/$visitPublicId'
    | '/admin'
    | '/visits'
    | '/admin/users/$publicId'
    | '/admin/users'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/analytics'
    | '/feedback'
    | '/forgot-password'
    | '/launch'
    | '/settings'
    | '/sign-up'
    | '/stripe'
    | '/templates'
    | '/admin/audit'
    | '/template/$templatePublicId'
    | '/template/new'
    | '/visits/$visitPublicId'
    | '/admin/'
    | '/visits/'
    | '/admin/users/$publicId'
    | '/admin/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AnalyticsRoute: typeof AnalyticsRoute
  FeedbackRoute: typeof FeedbackRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LaunchRoute: typeof LaunchRoute
  SettingsRoute: typeof SettingsRoute
  SignUpRoute: typeof SignUpRoute
  StripeRoute: typeof StripeRoute
  TemplatesRoute: typeof TemplatesRoute
  TemplateTemplatePublicIdRoute: typeof TemplateTemplatePublicIdRoute
  TemplateNewRoute: typeof TemplateNewRoute
  VisitsVisitPublicIdRoute: typeof VisitsVisitPublicIdRoute
  VisitsIndexRoute: typeof VisitsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feedback': {
      id: '/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof FeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/launch': {
      id: '/launch'
      path: '/launch'
      fullPath: '/launch'
      preLoaderRoute: typeof LaunchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stripe': {
      id: '/stripe'
      path: '/stripe'
      fullPath: '/stripe'
      preLoaderRoute: typeof StripeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates': {
      id: '/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof TemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/template/$templatePublicId': {
      id: '/template/$templatePublicId'
      path: '/template/$templatePublicId'
      fullPath: '/template/$templatePublicId'
      preLoaderRoute: typeof TemplateTemplatePublicIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/template/new': {
      id: '/template/new'
      path: '/template/new'
      fullPath: '/template/new'
      preLoaderRoute: typeof TemplateNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/visits/': {
      id: '/visits/'
      path: '/visits'
      fullPath: '/visits/'
      preLoaderRoute: typeof VisitsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/visits/$visitPublicId': {
      id: '/visits/$visitPublicId'
      path: '/visits/$visitPublicId'
      fullPath: '/visits/$visitPublicId'
      preLoaderRoute: typeof VisitsVisitPublicIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users/$publicId': {
      id: '/admin/users/$publicId'
      path: '/users/$publicId'
      fullPath: '/admin/users/$publicId'
      preLoaderRoute: typeof AdminUsersPublicIdRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminAuditRoute: typeof AdminAuditRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminUsersPublicIdRoute: typeof AdminUsersPublicIdRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAuditRoute: AdminAuditRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminUsersPublicIdRoute: AdminUsersPublicIdRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AnalyticsRoute: AnalyticsRoute,
  FeedbackRoute: FeedbackRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LaunchRoute: LaunchRoute,
  SettingsRoute: SettingsRoute,
  SignUpRoute: SignUpRoute,
  StripeRoute: StripeRoute,
  TemplatesRoute: TemplatesRoute,
  TemplateTemplatePublicIdRoute: TemplateTemplatePublicIdRoute,
  TemplateNewRoute: TemplateNewRoute,
  VisitsVisitPublicIdRoute: VisitsVisitPublicIdRoute,
  VisitsIndexRoute: VisitsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
